// Delivery Notes
export const SET_DELIVERY_NOTES_ITEMS = 'SET_DELIVERY_NOTES_ITEMS';
export const SET_IS_LOADING_DELIVERY_NOTES_ITEMS = 'SET_IS_LOADING_DELIVERY_NOTES_ITEMS';
export const SET_DELIVERY_NOTES_COLUMNS_ORDER = 'SET_DELIVERY_NOTES_COLUMNS_ORDER';
// Bills
export const SET_BILLS_ITEMS = 'SET_BILLS_ITEMS';
export const SET_IS_LOADING_BILLS_ITEMS = 'SET_IS_LOADING_BILLS_ITEMS';
export const SET_BILLS_COLUMNS_ORDER = 'SET_BILLS_COLUMNS_ORDER';
// Orders
export const SET_ORDERS_ITEMS = 'SET_ORDERS_ITEMS';
export const SET_IS_LOADING_ORDERS_ITEMS = 'SET_IS_LOADING_ORDERS_ITEMS';
export const SET_ORDERS_COLUMNS_ORDER = 'SET_ORDERS_COLUMNS_ORDER';
